/** URLs inyectadas por /tf3040-client-env.js (Development/Test en contenedor Docker). Production usa .env.production baked-in. */
function runtime() {
    if (typeof window !== 'undefined' && window.__TF3040_RUNTIME__) {
        return window.__TF3040_RUNTIME__;
    }
    return {};
}

// Convención del proyecto: los services concatenan paths sin "/" inicial
// (ej. urlAPI + 'identity/Account/authenticate'), así que el endpoint debe
// terminar en "/". Si la env viene sin barra (default histórico del compose
// de preprod), normalizamos acá para no generar URLs tipo
// "https://apidev.tf3040.com.aridentity/...".
function ensureTrailingSlash(url) {
    if (typeof url !== 'string' || url === '') {
        return url;
    }
    return url.endsWith('/') ? url : url + '/';
}

export function getApiEndpoint() {
    const fromEnv = process.env.VUE_APP_API_ENDPOINT;
    // `npm run serve` + .env.development vacío: mismo origen y proxy en vue.config.js; el script
    // /tf3040-client-env.js no debe pisar con una URL absoluta (volvería CORS).
    if (process.env.NODE_ENV === 'development' && fromEnv === '') {
        return '';
    }
    const r = runtime();
    if (Object.prototype.hasOwnProperty.call(r, 'apiEndpoint')) {
        return ensureTrailingSlash(r.apiEndpoint);
    }
    return ensureTrailingSlash(fromEnv);
}

export function getImageEndpoint() {
    const fromEnv = process.env.VUE_APP_IMAGE_ENDPOINT;
    if (process.env.NODE_ENV === 'development' && fromEnv === '') {
        return '';
    }
    const r = runtime();
    if (Object.prototype.hasOwnProperty.call(r, 'imageEndpoint')) {
        return ensureTrailingSlash(r.imageEndpoint);
    }
    return ensureTrailingSlash(fromEnv);
}
